<template>
    <v-container class="white mt-5">
    
        <div>
            <p>  {{ $t('changePass.title') }} </p>
        </div>

        <v-row>
            <v-col cols="12" sm="4">
                <v-text-field v-model="password" :append-icon="show ? 'visibility' : 'visibility_off'" :rules="passdRules" v-bind:label="$t('changePass.new_pass')" outlined :type="show ? 'text' : 'password'" required @click:append="show = !show"></v-text-field>
            </v-col>
        </v-row>
    
        <v-row>
            <v-col cols="12" sm="4">
                <v-text-field v-model="confirmPassword" :error-messages="vertifyPassword" :append-icon="show ? 'visibility' : 'visibility_off'" v-bind:label="$t('changePass.repeat_new_pass')"  outlined :type="show ? 'text' : 'password'" required @click:append="show = !show"></v-text-field>
            </v-col>
        </v-row>
    
        <v-row>
            <v-col cols="12" sm="4" class="mr-auto">
                <v-btn large block color="primary" class="normal-button" @click="resetPass"> {{ $t('changePass.btn_title') }} </v-btn>
            </v-col>
        </v-row>
    
    </v-container>
</template>

<script>

import i18n from '@/plugins/i18n';

export default {
    data: () => ({
        token: '',
        show: false,
        valid: true,
        password: '',
        confirmPassword: '',
        passdRules: [
            v => !!v || i18n.t('validate.password_require'),
            v => (v && v.length > 5) || i18n.t('validate.password_invalid'),
        ]
    }),

    computed: {
        vertifyPassword() {
            return this.password === this.confirmPassword ? '' : i18n.t('validate.not_match');
        }
    },

    methods: {
        resetPass: async function() {
            const self = this;
            const requestBody = {
                password: self.password
            };
            try {
                const response =  await this.$http.post(process.env.VUE_APP_CHANGE_PASSWORD_URL + this.$route.params.token, requestBody);
                if (response.data && response.data.success) {
                    this.$fire({
                        title: i18n.t('changePass.change_success'),
                        text: "",
                        type: "success"
                        }).then(() => {
                            this.$router.push('/login');
                    });
                } else if(!response.data.success) {
                    alert(i18n.t(response.data.message));
                } else {
                    alert(i18n.t('validate.request_error'));
                }  
            } catch(e) {
                console.log(e.stack);
                alert(i18n.t('validate.request_error'));
            }
        }
    }
}
</script>

<style scoped>
p {
    color: #1D243E;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    padding-top: 20px;
}
</style>